// External deps
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PropTypes from 'prop-types';

// Internal deps
import './CustomTooltip.scss';

const CustomToolTip = ({
  children, text, className, tooltipClassName
}) => (
  text ? (
    <OverlayTrigger
      delay={{
        show: 250,
        hide: 400
      }}
      key="top"
      placement="top"
      overlay={(
        <Tooltip className={`tooltip-size ${tooltipClassName}`}>
          {text}
        </Tooltip>
      )}
    >
      <button
        type="button"
        className={`adm-button-icon-tooltip ${className}`}
      >
        {children}
      </button>
    </OverlayTrigger>
  ) : (
    <div className={className}>
      {children}
    </div>
  )
);

CustomToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  tooltipClassName: PropTypes.string
};

CustomToolTip.defaultProps = {
  className: '',
  tooltipClassName: ''
};

export default CustomToolTip;
